module.exports = __webpack_public_path__ + "img/notion.043ced3d.png";